import React from 'react'
import Head from '../../components/Head'

export default (props) => (
  <div>
    <Head {...props} />
    <h3>API Limits</h3>
    <p>There are limits to the number of API calls that your application can make against the API</p>
    <ol style={{ listStyle: 'decimal', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
      <li>Daily Limit: 5 000 calls per day. If you have exhausted your limits and want to increase your limit, contact us</li>
    </ol>
    <p>If you exceed your limit you will receive a HTTP 409 Limit Exceeded Exception</p>
  </div>)



// WEBPACK FOOTER //
// ./src/pages/ApiLimit/index.js